import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import SurveysPage from 'components/pages/Surveys';

import pageTitles from 'utils/pageTitles';
import { setTitle, setActiveMenuItem } from 'containers/store';

import {
  onAddClick, onDelete, onEdit, onSearchSubmit, onDownloadSchema, loadPageData,
  onChangeSort, onChangePage, onChangeRowsPerPage, onPreview, onCopy, onDownloadCsv,
  onDownloadResults,
} from './store';

class Surveys extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onDownloadSchema: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onSearchSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.surveys));
    this.props.setActiveMenuItem('surveys');
    this.props.loadPageData();
  }

  render() {
    return this.props.isLoadedPage ? (
      <SurveysPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  setActiveMenuItem,
  onAddClick,
  onSearchSubmit,
  onDelete,
  onEdit,
  loadPageData,
  onDownloadSchema,
  onChangeSort,
  onChangePage,
  onChangeRowsPerPage,
  onPreview,
  onCopy,
  onDownloadCsv,
  onDownloadResults,
};

const mapStateToProps = (state) => ({
  ...state.Surveys,
  ...state.Global.pagingData,
  totalItemsCount: state.Surveys.totalItemsCount,
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Surveys));
